import { render, staticRenderFns } from "./KeyIndicatorUs.vue?vue&type=template&id=d98c79aa&scoped=true"
import script from "./KeyIndicatorUs.vue?vue&type=script&lang=js"
export * from "./KeyIndicatorUs.vue?vue&type=script&lang=js"
import style0 from "./KeyIndicatorUs.vue?vue&type=style&index=0&id=d98c79aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98c79aa",
  null
  
)

export default component.exports